import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactJWPlayer from 'react-jw-player'
import {
  ThemeProvider,
  Backdrop,
  Collapse,
  Box,
  Button,
  IconManager,
  coreIconPack,
} from '@deseretbook/react-ui'

IconManager.register(coreIconPack)

const videoPlayer = ({
  libraryUrl,
  videoUrl,
  videoPoster,
  videoContainerId,
  variantSku,
  returnPath,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [controlsAreCollapsed, setControlsAreCollapsed] = useState(true)

  const openPlayer = () => {
    window.history.pushState({}, '', `/watch/${variantSku}`)
    setIsOpen(true)
    window.jwplayer(videoContainerId).play()
    //window.jwplayer(videocontainerid).seek()
  }

  const closePlayer = () => {
    window.history.pushState({}, '', returnPath)
    setIsOpen(false)
    window.jwplayer(videoContainerId).pause()
  }

  const subscriber = (action, _) => {
    if (action !== 'watchVideoOnDemand')
      return
    openPlayer()
  }

  useEffect(() => {
    if (window.contextObserver)
      window.contextObserver.subscribe(subscriber)
  })

  return (
    <ThemeProvider>
      <Backdrop
        isOpen={isOpen}
        onMouseEnter={() => { setControlsAreCollapsed(false) }}
        onMouseLeave={() => { setControlsAreCollapsed(true) }}
      >
        <div style={{position: 'absolute', width: 'inherit', zIndex: '1'}}>
          <Collapse isCollapsed={controlsAreCollapsed} animateOpacity={true}>
            <Box
              paddingTop={1}
              paddingRight={1}
              justifyContent='flex-end'
            >
              <Button
                type='button'
                color='primary'
                icon='close'
                isRounded={true}
                onClick={closePlayer}
              />
            </Box>
          </Collapse>
        </div>
        <ReactJWPlayer
          image={videoPoster}
          playerId={videoContainerId}
          playerScript={libraryUrl}
          file={videoUrl}
        />
      </Backdrop>
    </ThemeProvider>
  )
}

videoPlayer.propTypes = {
  libraryUrl: PropTypes.string,
  videoUrl: PropTypes.string,
  videoPoster: PropTypes.string,
  videoContainerId: PropTypes.string,
  variantSku: PropTypes.string,
  returnPath: PropTypes.string,
}

export default videoPlayer
